/** 处理环境变量 */
const warpperEnv = (envConf: Recordable): ViteEnv => {
  /** 此处为默认值，无需修改 */
  const ret: ViteEnv = {
    VITE_PORT: 8848,
    VITE_PUBLIC_PATH: "",
    VITE_ROUTER_HISTORY: "",
    VITE_LEGACY: false,
    VITE_CDN: false,
    VITE_COMPRESSION: "none",
    VITE_RANDOM: "pyIZHiecL7U9BkEzfT3LRYy2",
    VITE_BASE_API: "",
    VITE_PROXY_DOMAIN: "",
    VITE_NODE_ENV: ""
  };

  for (const envName of Object.keys(envConf)) {
    let realName = envConf[envName].replace(/\\n/g, "\n");
    realName =
      realName === "true" ? true : realName === "false" ? false : realName;

    if (envName === "VITE_PORT") {
      realName = Number(realName);
    }
    ret[envName] = realName;
    if (typeof realName === "string") {
      process.env[envName] = realName;
    } else if (typeof realName === "object") {
      process.env[envName] = JSON.stringify(realName);
    }
  }
  return ret;
};

/** 环境变量 */
const loadEnv = (): ViteEnv => {
  return import.meta.env;
};

export { warpperEnv, loadEnv };
